import {createSlice} from '@reduxjs/toolkit';
import {QUICK_PRODUCT_VIEW} from '~/constants/ModalConstants';

const initialState = {key: null};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModal: (state, action) => action.payload,
    dismissModal: () => initialState
  }
});

export const {setModal, dismissModal} = modalSlice.actions;
export default modalSlice.reducer;

// Selectors
export const selectModal = state => state.modal;

export const selectIsQuickViewModalOpened = state =>
  state.modal.key === QUICK_PRODUCT_VIEW;
